import Field from "admin-config/lib/Field/Field";

class TimeOfDayField extends Field {
    constructor(name) {
        super(name);
        this._sortable = true;
        this._type = "time_of_day";
    }
}

export default TimeOfDayField;



// WEBPACK FOOTER //
// ./js/types/TimeOfDayField.js